import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import CasesPage from '@/pages/cases/page';
import CaseDetailPage from '@/pages/case/page';
import ChartsPage from '@/pages/charts/page';
import ResponsesPage from '@/pages/responses/page';
import ChainsPage from '@/pages/chains/page';
import AboutPage from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/cases',
    element: <CasesPage />,
  },
  {
    path: '/case/:id',
    element: <CaseDetailPage />,
  },
  {
    path: '/charts',
    element: <ChartsPage />,
  },
  {
    path: '/responses',
    element: <ResponsesPage />,
  },
  {
    path: '/chains',
    element: <ChainsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;